package one.healthium.domain.user.models


import kotlinx.serialization.Serializable

@Serializable
data class UserProfileModel(
    val name: String?,
    val age: Int?,
    val weight: Float?,
    val targetWeight: Float?,
    val height: Float?,
    val gender: Gender?,
    val email: String?,
    val avatarUrl: String?,
    val additionalInfo: Map<String, List<AdditionalUserInfoModel>>,
    val additionalText: Map<String, String>,
    val statements: Map<String, Int>,
) {
    companion object {
        val EMPTY = UserProfileModel(
            name = null,
            age = null,
            weight = null,
            targetWeight = null,
            height = null,
            gender = null,
            email = null,
            avatarUrl = null,
            additionalInfo = emptyMap(),
            additionalText = emptyMap(),
            statements = emptyMap(),
        )

        val preview = UserProfileModel(
            name = "Mary Weather",
            age = 45,
            weight = 90f,
            targetWeight = 80f,
            height = 170f,
            gender = Gender.Male,
            email = null,
            avatarUrl = null,
            additionalInfo = emptyMap(),
            additionalText = emptyMap(),
            statements = emptyMap(),
        )
    }
}

@Serializable
data class AdditionalUserInfoModel(
    val key: String,
    val text: String,
    val altText: String?,
)